window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.SCORING_CONFIG = {
  drinkCompatibility: { 3: 35, 2: 27, 1: 15, 0: null },
  tasteProfile: { singleSelected: { primary: 24, secondary: 6 }, multiSelected: { primaryEach: 18, secondaryEach: 5 }, max: 30 },
  adventureMatrix: { classic: { classic: 20, experiment: 8, goose: -15 }, experiment: { classic: 10, experiment: 20, goose: 8 }, goose: { classic: 2, experiment: 12, goose: 20 } },
  temperature: { exact: 8, recipeSupportsEither: 5, userChoseEither: 3 },
  spirit: { exact: 12, supportsSelectedAmongMultiple: 10, any: 6 },
  branchIntent: { exact: 10, related: 5 },
  familiarity: { classic: { 1: 6, 2: 5, 3: 0, 4: -5, 5: -8 }, experiment: { 1: 1, 2: 4, 3: 6, 4: 4, 5: -2 }, goose: { 1: -4, 2: 0, 3: 4, 4: 7, 5: 8 } },
  merchandisingMax: 5,
  seasonalMax: 4,
  diversity: { shownLastResult: -15, shownTwoResultsAgo: -8, shownThreeResultsAgo: -3, sameFlavourFamily: -4 },
  classicSoda: { categoryVibeMax: 40, tasteMax: 35, familiarityMax: 10, merchandisingMax: 5, seasonalityMax: 2 }
};
